import { render, staticRenderFns } from "./iconLegales-white.vue?vue&type=template&id=21bb2b23&scoped=true&"
import script from "./iconLegales-white.vue?vue&type=script&lang=js&"
export * from "./iconLegales-white.vue?vue&type=script&lang=js&"
import style0 from "./iconLegales-white.vue?vue&type=style&index=0&id=21bb2b23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb2b23",
  null
  
)

export default component.exports